import "./plugins";
import "./client/booking-overview";
import "./client/booking-form";
import "./client/booking-single-product-galleries";
import "./client/booking-cart";
import "./client/booking-filter";
import "./client/booking-cart-url";
import "./client/booking-reserveren";
import "./client/clear-storage";
